import { TypedDocumentNode, gql } from '@apollo/client';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import { GroupOverview } from 'components/rivalsUserGroup/GroupOverview';
import { ShareBlock } from 'components/rivalsUserGroup/ShareBlock';

import { InviteContent_rivalsUserGroup } from './__generated__/index.graphql';

type Props = {
  userGroup: Nullable<InviteContent_rivalsUserGroup>;
};
export const InviteContent = ({ userGroup }: Props) => {
  return (
    <Vertical>
      <GroupOverview userGroup={userGroup} bgColor="var(--c-neutral-200)" />
      <ShareBlock userGroup={userGroup} />
    </Vertical>
  );
};

InviteContent.fragments = {
  rivalsUserGroup: gql`
    fragment InviteContent_rivalsUserGroup on RivalsUserGroup {
      slug
      id
      ...GroupOverview_rivalsUserGroup
      ...ShareBlock_rivalsUserGroup
    }
    ${GroupOverview.fragments.rivalsUserGroup}
    ${ShareBlock.fragments.rivalsUserGroup}
  ` as TypedDocumentNode<InviteContent_rivalsUserGroup>,
};
